import { render, staticRenderFns } from "./baiDuAuthAccount.vue?vue&type=template&id=98c48036&scoped=true"
import script from "./baiDuAuthAccount.vue?vue&type=script&lang=js"
export * from "./baiDuAuthAccount.vue?vue&type=script&lang=js"
import style0 from "./baiDuAuthAccount.vue?vue&type=style&index=0&id=98c48036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c48036",
  null
  
)

export default component.exports